module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }